import type * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";

export interface OptionProps {
	children: React.ReactNode;
	disabled?: boolean;
	value: string | number;
	sx?: SxProps<Theme>;
}

export function Option({ children, ...props }: OptionProps): React.JSX.Element {
	return <MenuItem {...props}>{children}</MenuItem>;
}
